/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-12 18:13:57
 * @LastEditors: changfeng
 * @LastEditTime: 2024-04-13 12:20:14
 */
import {AnyAction} from "redux";
import {AccountState} from "@/redux/interface";
import produce from "immer";

const AccountStates: AccountState = {
	accountInfo: {}
};

// auth reducer
const Advertiser = (state: AccountState = AccountStates, action: AnyAction) =>
	produce(state, draftState => {
		switch (action.type) {
			case "SET_ADVERTISER_ACCOUNT":
				draftState.accountInfo = {...action.adv};
				break;

			default:
				return {...draftState};
		}
	});

export default Advertiser;
